import React from 'react';
import {ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip} from 'recharts';
import {getMonthShortName} from '../../../Helpers.js';


import './UserChart.css';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload) {
    return (
      <div className="UserChart-customTooltip">
        <p className="UserChart-customTooltip-label">{`${parseFloat(payload[0].value.toFixed(1))}`}</p>
      </div>
    );
  }

  return null;
};


const UserChart = (props) => {
  const getData = () => {
    if(props.monthlyResults.length){
      const data = props.monthlyResults.slice(0,6).reverse().map( (i) => ({
          month: getMonthShortName(i.month-1),
          year: i.year,
          pt: i.totalPoints,
          trainings: i.trainingsCnt
        })
      );
      return data;
    }
  }

  return (
      <div className="UserChart">
        <ResponsiveContainer width="99%" height={280}>
          <LineChart
            data={getData()}
            margin={{
              top: 5, right: 30, left: 20, bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" tick={{stroke: '#000'}}/>
            <YAxis tick={{stroke: '#000'}} orientation="left" />
            <Tooltip content={<CustomTooltip />}  />
            <Line type="monotone" dataKey="pt"
              isAnimationActive={false}
              stroke="#b3e6ff"
              dot={{stroke: '#2bb9ff', strokeWidth: 4, fill: '#fff', r: 6}}
              activeDot={{stroke: 'rgba(237,165,151,1)', strokeWidth: 4, fill: '#fff', r: 6}}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
  );

}
export default UserChart;



// WEBPACK FOOTER //
// ./src/screens/bfmPanel/UserChart/UserChart.js